import RadioSelectGuestTypeOption from "@/types/custom/RadioSelectGuestTypeOption";
import CommuneProjection from "@/types/projections/CommuneProjection";
import BIObject from "@/types/taxcard/BIObject";
import CommuneGuestTypeOption from "@/types/taxcard/CommuneGuestTypeOption";
import { GuestTypesEnum } from "@/types/taxcard/GuestType";

export function findGuestTypeOptionRadioValue(bIObject: BIObject, options: CommuneGuestTypeOption[]): string {
    for (let index = 0; index < options.length; index++) {
      const option = options[index];
      if (option.guestType == bIObject.bIObjectData.guestType && option.isAnnual == bIObject.bIObjectData.isAnnual && option.subGuestType == bIObject.bIObjectData.subGuestType){
        return `radioGuestType-${index}`;
      }
    }
    console.log("Reaching end of findGuestTypeOptionRadioValue");
    return 'radioGuestType-0';
  }
